// API
export const API_ROOT_URL = "/api/";
export const API_EP_GET_STATIONS = API_ROOT_URL + "stations/";
export const API_EP_GET_JOURNEYS = API_ROOT_URL + "journey/";
export const API_EP_MAP = API_ROOT_URL + "map/";
export const API_EP_GRAPH_OD_ALL_GRAPHS = API_ROOT_URL + "graph/allGraphs";
export const API_EP_GRAPH_OD_EVOL = API_ROOT_URL + "graph/evolution";
export const API_EP_GRAPH_OD_PERHOUR = API_ROOT_URL + "graph/perHour";
export const API_EP_GRAPH_OD_PERDAY = API_ROOT_URL + "graph/perDay";
export const API_EP_GRAPH_CSV_EVOL = API_ROOT_URL + "graph/evolutionCsv";
export const API_EP_GRAPH_CSV_PERHOUR = API_ROOT_URL + "graph/perHourCsv";
export const API_EP_GRAPH_CSV_PERDAY = API_ROOT_URL + "graph/perDayCsv";

// Content pages name
export const CONTENT_PAGE_ABOUT_A_PROPOS = "about_page/a_propos";
export const CONTENT_PAGE_ABOUT_SOURCE_DONNEES = "about_page/source_donnees";
export const CONTENT_PAGE_ABOUT_ACRONYMES = "about_page/acronymes";
export const CONTENT_PAGE_ABOUT_DEFINITIONS = "about_page/definitions";
export const CONTENT_PAGE_ABOUT_FONC_PREVISEO_1 = "about_page/fonc_previseo_1";
export const CONTENT_PAGE_ABOUT_FONC_PREVISEO_2 = "about_page/fonc_previseo_2";
export const CONTENT_PAGE_ABOUT_FONC_PREVISEO_3 = "about_page/fonc_previseo_3";
export const CONTENT_PAGE_ABOUT_FONC_PREVISEO_4 = "about_page/fonc_previseo_4";
export const CONTENT_PAGE_ABOUT_FONC_PREVISEO_5 = "about_page/fonc_previseo_5";
export const CONTENT_PAGE_ABOUT_FONC_ONGLETS = "about_page/fonc_onglets";
export const CONTENT_PAGE_ABOUT_A_PROPOS_ART = "about_page/a_propos_art";
export const CONTENT_MAP_EXPLAIN = "map-explain";

// Other
export const LOCAL_RESSOURCES_URL = "/locales/";
export const MAP_ATTRIBUTIONS_HTML =
  '<a href="https://www.autorite-transports.fr/" title="Autorité de Régulation des Transports">ART</a>' +
  " | " +
  '<a href="https://leafletjs.com" title="A JS library for interactive maps">Leaflet</a>';
